window.addEventListener("load", function () {
    if ( document.querySelectorAll('.playerSlider').length ) {

        const elements = document.querySelectorAll('.playerSlider');

        elements.forEach(function(element) {
            let playerSlider = new Swiper(element.querySelector(".swiper"), {
                watchOverflow: true,
                preloadImages: false,
                loop: true,
                lazy: {
                    checkInView: true,
                    loadPrevNext: true,
                    enabled: true
                },
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false
                },
                slidesPerView: 1,
                spaceBetween: 0,
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                        spaceBetween: 0,
                    },
                    445: {
                        slidesPerView: 1,
                        spaceBetween: 0,
                    },
                    645: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    800: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                    },
                    1885: {
                        slidesPerView: 3,
                        spaceBetween: 30,
                    },
                },

                navigation: {
                    nextEl: element.querySelector(".swiper-button-next"),
                    prevEl: element.querySelector(".swiper-button-prev"),
                }
            });
        });
    }
});
